<template>
  <companies-delivery-table
    :data="filteredData"
    :loading="isLoading"
    :search-query="searchQuery"
  />
</template>

<script>
import CompaniesDeliveryTable from "@/components/guest/CompaniesDeliveryTable.vue";
import hasPrinting from "@/mixins/hasPrinting";
import hasExcel from "@/mixins/hasExcel";

export default {
  name: "CompaniesDeliveryTab",
  mixins: [hasPrinting, hasExcel],
  components: {
    CompaniesDeliveryTable,
  },
  props: {
    searchQuery: String,
    dateRange: Array,
    selectedStatus: Object,
    isActiveTab: Boolean,
  },
  data() {
    return {
      data: [],
      isLoading: false,
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t("r_b"), value: "num", sortable: false },
        { text: this.$t("company"), value: "company", sortable: false },
        { text: this.$t("address"), value: "address", sortable: false },
        { text: this.$t("phone_no"), value: "phone", sortable: false },
        { text: this.$t("delivered_orders"), value: "orders", sortable: false, align: "center" },
      ];
    },
    restaurantId() {
      return this.$store.state.restaurant?.id;
    },
    filteredData() {
      if (!this.selectedStatus || this.selectedStatus.id === 0) {
        return this.data;
      }
      return this.data.filter(
        (item) => item.status === this.selectedStatus.id
      );
    },
  },
  watch: {
    isPrinting(isPrinting) {
      if (!isPrinting || !this.isActiveTab || !this.filteredData || this.filteredData.length === 0) {
        return;
      }

      this.printCompaniesTable();
    },
    isExcelDownloading(isDownloading) {
      if (!isDownloading || !this.isActiveTab || !this.filteredData || this.filteredData.length === 0) {
        return;
      }

      this.exportCompaniesExcel();
    },
    dateRange: {
      handler() {
        this.loadData();
      },
      immediate: true,
    },
    selectedStatus() {
      // Local filtering, no need to reload
    },
  },
  methods: {
    loadData() {
      // TODO: Implement API call
      console.log("Loading companies delivery data for:", this.dateRange, this.selectedStatus);
    },
    printCompaniesTable() {
      const tableItems = this.filteredData.map((item, index) => ({
        num: index + 1,
        company: item.company || '',
        address: item.address || '',
        phone: item.phone || '',
        orders: item.orders || 0,
      }));

      this.printDocument({
        pageTitle: this.$t('companies_delivery'),
        title: this.$t('companies_delivery'),
        subtitle: `${this.$t('date')}: ${this.dateRange[0]} - ${this.dateRange[1]}`,
        tables: [
          {
            headers: this.headers.map(h => ({ text: h.text, value: h.value, align: h.align })),
            items: tableItems,
          }
        ],
      });
    },
    exportCompaniesExcel() {
      const tableItems = this.filteredData.map((item, index) => ({
        num: index + 1,
        company: item.company || '',
        address: item.address || '',
        phone: item.phone || '',
        orders: item.orders || 0,
      }));

      this.downloadExcel({
        fileName: `firme_dostava_${this.dateRange[0]}_${this.dateRange[1]}.xlsx`,
        sheets: [
          {
            name: this.$t('companies_delivery'),
            title: this.$t('companies_delivery'),
            subtitle: `${this.$t('date')}: ${this.dateRange[0]} - ${this.dateRange[1]}`,
            headers: this.headers.map(h => ({ text: h.text, value: h.value, align: h.align })),
            items: tableItems,
          }
        ],
      });
    },
  },
};
</script>
